// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LoTov","comment":"styles_comment__2LX16"};